import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import QR from './QRCode';
import { fetchPollStateFb, listenForScores } from '../db';

interface IMatchParams {
  pollId: string;
}

interface IPollActivityViewerProps extends RouteComponentProps {
  poll: any;
  fetchPolls: () => void;
  listen: (pollId: string) => void;
  match: {
    isExact: any;
    path: any;
    url: any;
    params: IMatchParams;
  };
  dispatch: ThunkDispatch<any, any, any>;
}

const PollActivityViewer: React.SFC<IPollActivityViewerProps> = props => {
  const { pollId } = props.match.params;
  const { fetchPolls, listen, poll } = props;
  const { scores } = poll;

  useEffect(() => {
    fetchPolls();
    listen(pollId);
  }, [fetchPolls, listen, pollId]);

  const scoresLength = scores ? Object.keys(scores).length : 0;

  const scoresAvg: number = scores
      ? Object.keys(scores).reduce(
      (pre: number, key: string) => pre + parseFloat(scores[key]),
      0
  ) / scoresLength
      : 0;

  // TODO: Map out the average score simply here:
  return (
    <>
      {!scores && <QR pollId={pollId} {...props} />}
      {
        scores &&
        <>
          <p>Score Average: {scoresAvg.toFixed(1)}</p>
        </>
      }
    </>
  );
};

const mapStateToProps = (state: any, ownProps: IPollActivityViewerProps) => {
  const { pollId } = ownProps.match.params;
  const polls = { ...state.polls };
  const thisPoll = polls[pollId] || { scores: undefined };
  return { poll: thisPoll };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    fetchPolls: () => dispatch(fetchPollStateFb),
    listen: (pollId: string) => dispatch(listenForScores(pollId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PollActivityViewer);
